import { useCallback } from 'react';
import { ranksService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Rank } from '../types';

export function useRanks(
  options?: ResourceQueryOptions
): ResourceState<Rank> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      ranksService.getAll(opts) as unknown as Promise<{ data: Rank[]; meta?: any }>,
    []
  );
  return useResourceCollection<Rank>(fetchFn, options);
}

export function useRank(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Rank> {
  const resourceId = id;
  const fetchFn = useCallback(
    (rankId: string | number, opts?: ResourceQueryOptions) =>
      ranksService.getById(rankId, opts) as unknown as Promise<Rank>,
    []
  );
  return useResourceById<Rank>(fetchFn, resourceId, options);
}

export function useCreateRank(
  onSuccess?: (data: Rank) => void
): MutationState<Rank> {
  const createFn = useCallback(
    (data: any) => ranksService.create(data) as unknown as Promise<Rank>,
    []
  );
  return useCreateResource<Rank>(createFn, onSuccess);
}

export function useUpdateRank(
  onSuccess?: (data: Rank) => void
): MutationState<Rank> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return ranksService.update(id, data) as unknown as Promise<Rank>;
    },
    []
  );
  return useUpdateResource<Rank>(updateFn, onSuccess);
}

/**
 * Delete rank using documentId
 * @param data - Full rank object containing documentId
 */
export function useDeleteRank(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return ranksService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
